import { useMemo } from 'react';
import { verifiers } from '@yola/subscription-manager-js';
import { t } from '../../localization';

const useCompactPlansData = ({
  computedPlans,
  planFeatures,
  activeCompactPlans,
  captions,
  isFreePlanAvailable,
  onCollapseClick,
}) =>
  useMemo(
    () =>
      computedPlans.map((plan) => {
        const { type } = plan;
        const collapsed = !activeCompactPlans.includes(type);

        let cta =
          captions?.plan?.buttonLabel ||
          t('Start with {planName}', {
            planName: plan.captions.name || type,
          });

        if (verifiers.isFreeHostingPackageType(type) && isFreePlanAvailable) {
          cta = t('Continue for Free');
        }

        return {
          ...plan,
          captions: {
            ...plan.captions,
            cta,
          },
          availabilities: planFeatures.reduce((availabilities, feature) => {
            if (feature.disabled) {
              return availabilities;
            }

            const targetAvailability = feature.availabilities.find(
              (availability) => availability.id === plan.type
            );

            if (targetAvailability && targetAvailability.compact !== null) {
              const { compact, contentType } = targetAvailability;
              availabilities.push({ text: compact, contentType });
            }

            return availabilities;
          }, []),
          collapsed,
          type,
          onCollapseClick,
        };
      }),
    [
      computedPlans,
      planFeatures,
      onCollapseClick,
      activeCompactPlans,
      isFreePlanAvailable,
      captions?.plan?.buttonLabel,
    ]
  );

export default useCompactPlansData;
